import { ORDERS_ACCESS } from '@/helpers/permissionsConstant'

export default [
  {
    path: '/admin/exports/pending',
    name: 'exports-pending',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Pending Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'pending',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Pending Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/processing',
    name: 'exports-processing',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Processing Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'processing',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Processing Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/packing',
    name: 'exports-packing',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Packing Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'packing',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Packing Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/shipping',
    name: 'exports-shipping',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Shipping Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'shipping',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Shipping Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/on_the_way',
    name: 'exports-on_the_way',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'On The Way Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'on_the_way',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'On The Way', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/in_review',
    name: 'exports-in_review',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'In Review Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'in_review',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'In Review', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/rejected',
    name: 'exports-rejected',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Rejected Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'rejected',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Rejected Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/returned',
    name: 'exports-returned',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Returned Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'returned',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Returned Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/canceled',
    name: 'exports-canceled',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Canceled Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'canceled',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Canceled Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/delivered',
    name: 'exports-delivered',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Delivered Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'delivered',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Delivered Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/pending-1',
    name: 'exports-pending-1',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Pending 1 Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'pending-1',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Pending 1 Orders', active: true },
      ],
    },
  },
  {
    path: '/admin/exports/pending-2',
    name: 'exports-pending-2',
    component: () => import('@/views/exports/Status.vue'),
    meta: {
      pageTitle: 'Pending 2 Orders Export',
      gate: ORDERS_ACCESS,
      exportStatus: 'pending-2',
      breadcrumb: [
        { text: 'Exports' },
        { text: 'Pending 2 Orders', active: true },
      ],
    },
  },
]
